import styles from '../UnitManagementProcess.module.scss';
import {FC, useState} from 'react';
import {InputValidationError} from '../../../../common/Input/ValidationError';
import {PeoplePicker} from '../../../../common/PeoplePicker';

interface IProcessRowOwnersProps {
  model: {
    processOwnerAzureId: string | undefined;
    secondaryProcessOwnerAzureIds?: string[] | undefined;
    isChecked?: boolean;
  };
  ownerType?: 'secondaryProcessOwnerAzureIds';
  required?: boolean;
  readonly?: boolean;
  disabled?: boolean;
}

export const ProcessRowOwners: FC<IProcessRowOwnersProps> = ({
  model,
  ownerType = 'secondaryProcessOwnerAzureIds',
  required = true,
  readonly,
  disabled
}) => {
  const owners = model[ownerType];

  const [ownerAzureIds, setOwnerAzureIds] = useState<string[] | undefined>(owners);
  const isError = !readonly && required && model.isChecked && !ownerAzureIds;
  const isTheSameOwner =
    ownerType === 'secondaryProcessOwnerAzureIds' &&
    model.processOwnerAzureId && owners?.some(id => id === model.processOwnerAzureId) &&
    model.processOwnerAzureId !== undefined &&
    model.isChecked;

  return (
    <div className={`multipleOwners ${styles.inputWrapper}`}>
      <PeoplePicker
        itemLimit={50}
        isDisabled={disabled}
        isReadonly={readonly}
        defaultSelectedPersonIds={owners}
        onSelectPerson={person => {
          const azureId = person ? person.map(p => p.id).filter((id): id is string => id !== undefined) : undefined;
          model[ownerType] = azureId;
          setOwnerAzureIds(azureId);
        }}
        className={`${styles.regularOwner}${isError ? ` ${styles.error}` : ''}`}
      />
      {isError ? (
        <InputValidationError message={'This value could not be empty. Choose Process Owner.'} />
      ) : null}
      {isTheSameOwner && (
        <InputValidationError
          message={"Secondary Process Owner cannot be the same as Process Owner"}
        />
      )}
    </div>
  );
};
